export default __webpack_public_path__ + "static/media/afr_4.1ae92bbf.png";